import { ApolloError } from '@apollo/client';
import { HTTP_STATUS } from 'constants/httpStatus';

export const isUnauthorizedApolloError = (error: Error): boolean =>
  error instanceof ApolloError &&
  error.networkError !== null &&
  'statusCode' in error.networkError &&
  error.networkError.statusCode === HTTP_STATUS.UNAUTHORIZED;
